import React from 'react'
import styles from './ProspectoFinal.module.css'
import imgSolicitudFinal from '../../img/img-solicitud-final.jpg'
import Header from '../../components/Header'
import CardFull from '../ResumenADN/components/card/full'
import stylesCard from '../ResumenADN/ResumenADN.module.css'

const ProspectoFinal = ({ history }) => {
  const handleNuevaSolitud = () => {
    history.push('/home')
  }

  return (
    <React.Fragment>
      <Header history={history} />
      <section style={{ backgroundColor: '#f8fafb', minHeight: 'calc(100vh - 80px)' }}>
          <div className={stylesCard.container__full} style={{ maxWidth: '951px', margin: '0 auto', paddingTop: '32px' }}>
              <CardFull>
                  <div className={stylesCard.container__wrapper}>
                      <div className={styles["areadatosprospecto "]}>
                          <p className={styles["areaimgfinal"]}>
                              <img src={imgSolicitudFinal} alt="" />
                          </p>
                          <p className={styles["txtfinal"]}>
                              ¡Gracias por confiar en nosotros!<br />
                              Pronto estarás recibiendo un correo con mayor detalle de tu compra
                          </p><br />
                          <div className={styles["w3areabtn"]}>
                              <button className={styles["btnpagoaccion"]} onClick={handleNuevaSolitud}>Nueva solicitud</button>
                          </div>
                      </div>
                  </div>
              </CardFull>
          </div>
      </section>
    </React.Fragment>
  )
}


export default ProspectoFinal